import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { PeriodsModels, PeriodSourceModels } from './PeriodsModels';
import type { APIResponse } from '../../Shared/shared';

export const AddGlPeriods = createAsyncThunk(
  'Periods/AddGlPeriods',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Finance/AddGlPeriods', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatGlPeriods = createAsyncThunk(
  'Periods/UpdatGlPeriods',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Finance/UpdatGlPeriods', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetGlPeriodsList = createAsyncThunk(
  'Periods/GetGlPeriodsList',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('Finance/GetGlPeriodsList');
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetGlPeriodsById = createAsyncThunk(
  'Periods/GetGlPeriodsById',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Finance/GetGlPeriodsById?Id=${id}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetGlPeriodsByPeriodYear = createAsyncThunk(
  'Periods/GetGlPeriodsByPeriodYear',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Finance/GetGlPeriodsByPeriodYear?PeriodYear=${id}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/GetGlPeriodsByPeriodYear',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Finance/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatePeriodSource = createAsyncThunk(
  'Periods/UpdatePeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>('Finance/UpdatePeriodSource', item);
      if (data.succeeded === true && data.data === true) {
        dispatch(getPeriodSourceByPeriodId(item.periodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

//~~~~~~Inv
export const getInvPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getInvPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Inv/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateInvPeriodSource = createAsyncThunk(
  'Periods/UpdateInvPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    debugger;
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `Inv/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getInvPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

//~~~~~~Purchase
export const getPurPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getPurPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(
        `PurchaseBill/GetPeriodSourceByPeriodId?PeriodId=${periodId}`
      );
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdatePurPeriodSource = createAsyncThunk(
  'Periods/UpdatePurPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    debugger;
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `PurchaseBill/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getPurPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
//~~~~~~Ap
export const getApPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getApPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Ap/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateApPeriodSource = createAsyncThunk(
  'Periods/UpdateApPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    debugger;
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `Ap/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getApPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
//~~~~~~Ar
export const getArPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getArPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Ar/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateArPeriodSource = createAsyncThunk(
  'Periods/UpdateArPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    debugger;
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `Ar/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getArPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
//~~~~~~Ar
export const getFaPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getFaPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`FA/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateFaPeriodSource = createAsyncThunk(
  'Periods/UpdateFaPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
     try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `FA/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getArPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

//~~~~~~Fleet
export const getFleetPeriodSourceByPeriodId = createAsyncThunk(
  'Periods/getFleetPeriodSourceByPeriodId',
  async (periodId: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Fleet/GetPeriodSourceByPeriodId?PeriodId=${periodId}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateFleetPeriodSource = createAsyncThunk(
  'Periods/UpdateFleetPeriodSource',
  async (item: any, { rejectWithValue, dispatch }) => {
    debugger;
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `Fleet/UpdatePeriodSource?PeriodId=${item.PeriodId}&ActiveFlag=${item.ActiveFlag}`
      );
      if (data.succeeded === true && data.data === true) {
        dispatch(getArPeriodSourceByPeriodId(item.PeriodId));
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  PeriodsList: PeriodsModels[];
  PeriodsById?: PeriodsModels;
  loading: boolean;
  error: any | null;
  //~~
  PeriodSourceList: PeriodSourceModels[];
  loading2: boolean;
  error2: any | null;
} = {
  PeriodsList: [],
  PeriodsById: {} as PeriodsModels,
  loading: false,
  error: null,
  //~~~
  PeriodSourceList: [],
  loading2: false,
  error2: null,
};

const PeriodsSlice = createSlice({
  name: 'Periods',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(AddGlPeriods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddGlPeriods.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.PeriodsList.push(action.payload.data);
      })
      .addCase(AddGlPeriods.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(GetGlPeriodsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetGlPeriodsList.fulfilled, (state, action: PayloadAction<PeriodsModels[]>) => {
        state.loading = false;
        state.PeriodsList = action.payload;
      })
      .addCase(GetGlPeriodsList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(GetGlPeriodsById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetGlPeriodsById.fulfilled, (state, action: PayloadAction<PeriodsModels>) => {
        state.loading = false;
        state.PeriodsById = action.payload;
      })
      .addCase(GetGlPeriodsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getInvPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getInvPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getInvPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getPurPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getPurPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getPurPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getApPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getApPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getApPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getArPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getArPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getArPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getFaPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getFaPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getFaPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~
      .addCase(getFleetPeriodSourceByPeriodId.pending, (state, action) => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getFleetPeriodSourceByPeriodId.fulfilled,
        (state, action: PayloadAction<PeriodSourceModels[]>) => {
          state.loading2 = false;
          state.PeriodSourceList = action.payload;
        }
      )
      .addCase(getFleetPeriodSourceByPeriodId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  },
});

export default PeriodsSlice.reducer;
